import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Notifications from "@/pages/Notifications.vue";

import Meeting from "@/pages/Meeting.vue"
import Meetings from "@/pages/Meetings.vue"

import Login11 from "../pages/Login11.vue";
import Loginew from "../pages/Login.vue";
import MeetingDetails from "../pages/EW/MeetingDetails.vue";
import NewMeetingIn from '../pages/EW/NewMeeting.vue'
import Admin from '../pages/ADMIN/Admin.vue'
import AdminEW from '../pages/ADMIN/AdminEW.vue'
import Application from '../pages/ADMIN/Application.vue'
import ApplicationEW from '../pages/ADMIN/ApplicationEW.vue'
import AllMeetings from '../pages/ADMIN/AllMeetings.vue'
import Institution from '../pages/ADMIN/Institution.vue'
import ZoomContracts from '../pages/ADMIN/ZoomContracts.vue'
import Contracts from '../pages/ADMIN/components/Contract.vue'
import Account from '../pages/ADMIN/Account.vue'
const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/login",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "login_ew/:id",
        name: "Login",
        component: Loginew
      },
      {
        path: "stats",
        name: "stats",
        component: UserProfile,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "application/:id",
        name: "Application",
        component: Application,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "application/:id/institutions/:insid",
        name: "Institution",
        component: Institution,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "admin",
        name: "Admin",
        component: Admin,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "contracts",
        name: "Zoom Contracts",
        component: ZoomContracts,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "contracts/:id",
        name: "Zoom Contracts",
        component: Contracts,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "contracts/:id/rooms",
        name: "Zoom Contracts",
        component: Account,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "meeting/:id",
        name: "Meeting Details",
        component: Meeting,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "notifications",
        name: "notifications",
        component: Notifications,
        meta: {
          requiresAuth: true,
        }
      }
    ]
  },
  {
    path:"/meetings",
    component: Meetings,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path:"/allmeetings/:id",
    component: AllMeetings
  },
  {
    path:"/allmeetings",
    component: AllMeetings
  },
  {
    path: "/login",
    name: "Login EW",
    component: Login11
  },
  {
    path: "/meeting_details/:id",
    component: Meeting,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/add_meeting/:key",
    component: NewMeetingIn
  },
  {
    path: "/get_meeting/:id",
    name:"Details",
    component: MeetingDetails
  },
  {
    path: "/admin/:id",
    name: "Admin EW",
    component: AdminEW,
  },
  {
    path: "/application_ew/:id",
    name: "Application EW",
    component: ApplicationEW,
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
